"use client";
import { useState as T, useMemo as S } from "react";
const X = (c) => {
  switch (c) {
    case "asc":
      return "desc";
    case "desc":
      return;
    default:
    case void 0:
      return "asc";
  }
}, A = (c, s) => {
  let l, p;
  s == null || s.forEach((n) => {
    var t, o;
    p = (o = (t = n.cells.find((i) => {
      var e;
      return ((e = i.sortable) == null ? void 0 : e.direction) !== void 0;
    })) == null ? void 0 : t.sortable) == null ? void 0 : o.direction, l = n.cells.findIndex((i) => {
      var e;
      return ((e = i.sortable) == null ? void 0 : e.direction) !== void 0;
    }), l = l === -1 ? void 0 : l;
  });
  const [r, k] = T({ column: l, direction: p }), x = (n, t) => {
    var i;
    (i = n.sortable) != null && i.onClick && n.sortable.onClick();
    const o = r.column === t ? r.direction : void 0;
    k({ column: t, direction: X(o) });
  }, B = S(
    () => s == null ? void 0 : s.map((n) => ({
      ...n,
      cells: n.cells.map((t, o) => t.sortable === void 0 ? t : {
        ...t,
        sortable: {
          ...t.sortable,
          onClick: () => x(t, o)
        }
      })
    })),
    [s, r]
  ), D = S(() => {
    var e;
    if (r.direction === void 0)
      return c;
    const n = [...c], t = r.column ?? 0, o = (e = s == null ? void 0 : s[0].cells[t].sortable) == null ? void 0 : e.sortBy, i = o === null;
    return (t !== void 0 && t >= 0 || !i) && n.sort((f, m) => {
      var b, C;
      const H = ((b = f.cells[t].children) == null ? void 0 : b.valueOf()).props, J = ((C = m.cells[t].children) == null ? void 0 : C.valueOf()).props, v = (a) => {
        var g;
        return (g = a.cells[t].children) == null ? void 0 : g.toString();
      }, O = (o == null ? void 0 : o(H)) ?? v(f) ?? "", P = (o == null ? void 0 : o(J)) ?? v(m) ?? "";
      let u = O, d = P;
      if (r.direction === "desc") {
        const a = d;
        d = u, u = a;
      }
      return u.localeCompare(d, void 0, { numeric: !0, sensitivity: "base" });
    }), n;
  }, [r, c]);
  return {
    sortedHead: B,
    sortedBody: D,
    sorting: r
  };
};
export {
  A as default
};
